// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n7-1";
export var messageSideRight = "_n7-2";
export var orderLookupBubbleContainer = "_n7-0";
export var submitButton = "_n7-3";